<div class="container mobile">
  <div class="section">
    <div class="title">
      {{'Général' | translate}}
    </div>
    <div class="equipments">
      <div class="equipment">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_personnes.png" alt="personnes">
        </div>
        <div class="description">
          6+
        </div>
      </div>
      <div class="equipment">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_lit.png" alt="lit">
        </div>
        <div class="description">
          3
        </div>
      </div>
      <div class="equipment">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_sdb.png" alt="personnes">
        </div>
        <div class="description">
          3
        </div>
      </div>
      <div class="equipment">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_cuisine.png" alt="personnes">
        </div>
        <div class="description">
          2
        </div>
      </div>
      <div class="equipment">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_wifi.png" alt="personnes">
        </div>
        <div class="description">
          wifi
        </div>
      </div>
      <div class="equipment">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_airco.png" alt="personnes">
        </div>
        <div class="description">
          A/C
        </div>
      </div>
      <div class="equipment">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_piscine.png" alt="personnes">
        </div>
        <div class="description">
          {{'piscine' | translate}}
        </div>
      </div>
      <div class="equipment">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_parking.png" alt="personnes">
        </div>
        <div class="description">
          parking
        </div>
      </div>
    </div>
  </div>
  <div class="section">
    <div class="title">
      {{'Haut' | translate}}
    </div>
    <div class="equipments">
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_lit.png" alt="lit">
          <div class="pic-desc">
            {{'Chambre' | translate}}
          </div>
        </div>
        <div class="description">
          {{'2 lits jumeaux 90x200' | translate}}, <br>
          Smart TV
        </div>
      </div>
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_cuisine.png" alt="cuisine">
          <div class="pic-desc">
            {{'Cuisine' | translate}}
          </div>
        </div>
        <div class="description">
          {{'Réfrigérateur' | translate}}, {{'Congélateur' | translate}}, {{'Cuisinière' | translate}},
          {{'Four' | translate}}, {{'Four M-O' | translate}}, {{'Grille-pain' | translate}},
          {{'Percolateur' | translate}}, {{'Bouilloire' | translate}},
          {{'Presse-agrumes' | translate}}, {{'Ustensiles de cuisine' | translate}},
          {{'Vaisselle' | translate}}, {{'Couverts' | translate}}
        </div>
      </div>
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_sdb.png" alt="sdb">
          <div class="pic-desc">
            {{'Salle de bain' | translate}}
          </div>
        </div>
        <div class="description">
          {{'Douche' | translate}}, {{'Baignoire' | translate}}, {{'Lavabo' | translate}},
          {{'WC' | translate}}
        </div>
      </div>
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_sejour.png" alt="sejour">
          <div class="pic-desc">
            {{'Séjour' | translate}}
          </div>
        </div>
        <div class="description">
          {{'Table repas + 4 chaises' | translate}} <br />
          {{'Salon avec canapé-lit' | translate}}
        </div>
      </div>
    </div>
  </div>
  <div class="section">
    <div class="title">
      {{'Bas' | translate}}
    </div>
    <div class="equipments">
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_lit.png" alt="lit">
          <div class="pic-desc">
            {{'Chambre' | translate}} 1
          </div>
        </div>
        <div class="description">
          {{'Lit king-size' | translate}} 160x200
        </div>
      </div>
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_lit.png" alt="lit">
          <div class="pic-desc">
            {{'Chambre' | translate}} 2
          </div>
        </div>
        <div class="description">
          {{'Lit king-size' | translate}} 160x200, minibar
        </div>
      </div>
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_cuisine.png" alt="cuisine">
          <div class="pic-desc">
            {{'Cuisine' | translate}}
          </div>
        </div>
        <div class="description">
          {{'Réfrigérateur' | translate}}, {{'Congélateur' | translate}},
          {{'Taques céramiques' | translate}}, {{'Four multifonctions' | translate}},
          {{'Lave-vaisselle' | translate}}, {{'Grille-pain' | translate}},
          {{'Percolateur' | translate}}, {{'Bouilloire' | translate}}, {{'Presse-agrumes' | translate}},
          {{'Ustensiles de cuisine' | translate}}, {{'Vaisselle' | translate}}, {{'Couverts' | translate}}
        </div>
      </div>
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_sdb.png" alt="sdb">
          <div class="pic-desc">
            {{'Salle de Bain' | translate}} 1
          </div>
        </div>
        <div class="description">
          {{'Baignoire' | translate}} + {{'douche' | translate}}, {{'Lavabo' | translate}},
          {{'WC' | translate}}
        </div>
      </div>
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_sdb.png" alt="sdb">
          <div class="pic-desc">
            {{'Salle de Bain' | translate}} 2
          </div>
        </div>
        <div class="description">
          {{'Douche' | translate}}, {{'Lavabo' | translate}}, {{'WC' | translate}}
        </div>
      </div>
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_sejour.png" alt="séjour">
          <div class="pic-desc">
            {{'Séjour' | translate}}
          </div>
        </div>
        <div class="description">
          {{'Table repas' | translate}} + 6 {{'chaises' | translate}}<br>
          {{'Bar' | translate}} + 4 {{'tabourets' | translate}}<br>
          {{'Salon avec canapé-lit' | translate}}, <br>
          Smart TV
        </div>
      </div>
    </div>
  </div>
  <div class="section">
    <div class="title">
      {{'Communs' | translate}}
    </div>
    <div class="equipments">
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_buanderie.png" alt="buanderie">
          <div class="pic-desc">
            {{'Buanderie' | translate}}
          </div>
        </div>
        <div class="description">
          {{'Lave-linge' | translate}}, {{'Fer et table à repasser' | translate}},
          {{'Etendoir' | translate}}, {{'Aspirateur' | translate}},
          {{'Ustensiles de ménage' | translate}}, {{'WC' | translate}}
        </div>
      </div>
      <div class="equipment" [class.isMobile]="isMobile">
        <div class="pic">
          <img src="../../../assets/Equipment/icone_exterieur.png" alt="exterieur">
          <div class="pic-desc">
            {{'Extérieurs' | translate}}
          </div>
        </div>
        <div class="description">
          {{'Piscine' | translate}} 25m², {{'Lits de soleil' | translate}}, {{'Douche' | translate}},
          {{'Tables' | translate}}, {{'Chaises' | translate}}, {{'Parasols' | translate}},
          {{'Barbecue' | translate}}, {{'Jardin' | translate}}
        </div>
      </div>
    </div>
  </div>
  <div class="section">
    <div class="equipment" [class.isMobile]="isMobile" innerHTML="{{equipment1.text}}">
    </div>
  </div>
</div>